:host {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.result-block-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  min-height: 32px;
  margin-bottom: var(--qds-navigation-gap-children-unrelated, 1.5rem);
}

.result-block-top__right {
  margin-right: 8px;
}

.result-block-top__title {
  font-weight: 400;
  font-size: var(--qds-control-small-text, 0.875rem);
  line-height: var(--qds-control-small-line-height, 1rem);
}
